export const getPurchaseStatusSystemName = {
  generated: 'Generated',
  sent_for_approval: 'Sent For Approval',
  approved: 'Approved',
  rejected: 'Rejected',
  ordered: 'Ordered',
  partially_received: 'Partially Received',
  received: 'Received',
  closed: 'Closed',
  cancelled: 'Cancelled',
}
